import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import { SxStyle } from '../../../types';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { Grid } from '@mui/material';
import { useStringsContext } from '../../../contexts/strings';

const styles: SxStyle = {
  root: (theme) => ({
    minWidth: 275,
    color: theme.palette.primary.main,
    borderColor: theme.palette.primary.main,
    borderWidth: '0.75px',
    margin: 10,
  }),
  title: (theme) => ({
    fontSize: '14px',
    textAlign: 'center',
    color: theme.palette.primary.main,
    marginBottom: '5px',
  }),
  valueText: (theme) => ({
    textAlign: 'center',
    color: theme.palette.primary.main,
  }),
};

export default function SummaryHeader({
  messageSummary,
}: InferProps<typeof SummaryHeader.propTypes>) {
  const { strings } = useStringsContext();

  return (
    <Grid container alignItems="center" justifyContent="space-evenly">
      <Grid item>
        <Card sx={styles.root} variant="outlined">
          <CardContent>
            <Typography sx={styles.title} gutterBottom>
              {strings.messagesViewer.numberOfMatches}
            </Typography>
            <Typography sx={styles.valueText} variant="h5" component="h2">
              {messageSummary.numberOfMatches}
            </Typography>
          </CardContent>
        </Card>
      </Grid>
      <Grid item>
        <Card sx={styles.root} variant="outlined">
          <CardContent>
            <Typography sx={styles.title} gutterBottom>
              {strings.messagesViewer.totalMessagesSent}
            </Typography>
            <Typography sx={styles.valueText} variant="h5" component="h2">
              {messageSummary.totalMessagesSent}
            </Typography>
          </CardContent>
        </Card>
      </Grid>
      <Grid item>
        <Card sx={styles.root} variant="outlined">
          <CardContent>
            <Typography sx={styles.title} gutterBottom>
              {strings.messagesViewer.averageMessagesPerMatch}
            </Typography>
            <Typography sx={styles.valueText} variant="h5" component="h2">
              {messageSummary.averageMessagesPerMatch}
            </Typography>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
}

SummaryHeader.propTypes = {
  messageSummary: PropTypes.shape({
    totalMessagesSent: PropTypes.number,
    numberOfMatches: PropTypes.number,
    averageMessagesPerMatch: PropTypes.any,
  }).isRequired,
};
